import React from "react";
import { NavLink } from "react-router-dom";
import { LayoutDashboard, Package, ArrowLeftRight } from "lucide-react";

const links = [
  { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "mobile-nav-dashboard" },
  { to: "/prodotti", label: "Prodotti", icon: Package, testid: "mobile-nav-products" },
  { to: "/movimenti", label: "Movimenti", icon: ArrowLeftRight, testid: "mobile-nav-movements" },
];

export default function BottomNav() {
  return (
    <nav className="bottom-nav" data-testid="bottom-nav">
      {links.map(({ to, label, icon: Icon, testid }) => (
        <NavLink
          key={to}
          to={to}
          end={to === "/"}
          className={({ isActive }) => (isActive ? "active" : "")}
          data-testid={testid}
        >
          <Icon className="w-5 h-5" />
          <span>{label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
